import React, { Component } from "react";
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";
import { Grid, Box, Typography } from "@mui/material";

class WorldEvangelizationPage extends Component {
  render() {
    return (
      <React.Fragment>
        {/* Full Width Menu */}
        <div className="container-fluid position-relative p-0">
          <MenuBar />
        </div>

        <div>
          {/* Title Section with Overlay */}
          <div className="container-fluid p-0">
            <div
              className="banner-image"
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/images/Global-Services-Banner.jpg)`,
              }}
            >
              <div className="banner-heading text-center wow fadeInDown">
                <h1 className="text-white">World Evangelization</h1>
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="container mt-4 mb-5">
            {/* Alternating Image and Text Sections */}

            {/* First Row (Text -> Image) */}
            <Grid
              container
              spacing={4}
              alignItems="center"
              sx={{ marginBottom: 5 }}
            >
              <Grid item xs={12} md={6} order={{ xs: 1, md: 1 }}>
                <Box sx={{ paddingLeft: { xs: 0, md: 3 } }}>
                  <p >
                    The Word of God is boundless and cannot be limited to any
                    particular geographical location. The Marian Retreat Centre
                    has been entrusted with the mission of spreading this
                    message to every corner of the globe. In pursuit of this
                    mission, world evangelization is given significant priority
                    in the missionary activities of Marian and Rev. Fr. Dominic
                    Valanmanal. Today, the Grace Anointing ministry of Marian
                    Retreat Centre has spread its wings to more than sixty
                    countries across the world. Another 36 countries are served
                    online.
                  </p>
                </Box>
              </Grid>
              <Grid item xs={12} md={6} order={{ xs: 2, md: 2 }}>
                <img
                  className="img-fluid shadow-sm"
                  src={`${process.env.PUBLIC_URL}/images/We1.png`}
                  alt="Marian Adoration"
                />
              </Grid>
            </Grid>

            {/* Second Row (Image -> Text) */}
            <Grid
              container
              spacing={4}
              alignItems="center"
              sx={{ marginBottom: 5 }}
            >
              <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
                <img
                  className="img-fluid shadow-sm"
                  src={`${process.env.PUBLIC_URL}/images/Rome2.png`}
                  alt="Rome Retreat"
                />
              </Grid>
              <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
                <Box sx={{ paddingLeft: { xs: 0, md: 3 } }}>
                  <p >
                    The Holy Spirit uses the hands of Rev. Fr. Dominic to break
                    the manacles of the devil and set free God‘s children. The
                    Holy Spirit guides Fr. Dominic into devoting his time to
                    serving the Lord by ministering to the people both in India
                    and in foreign lands. As John 8:36 says, “So if a son frees
                    you, then you will truly be free.” Retreats and conventions
                    are conducted in these countries. Marian has a dedicated
                    team of 400-plus committed volunteers to help organize
                    events across the world.
                  </p>
                </Box>
              </Grid>
            </Grid>

            {/* Third Row (Text -> Image) */}
            <Grid
              container
              spacing={4}
              alignItems="center"
              sx={{ marginBottom: 5 }}
            >
              <Grid item xs={12} md={6} order={{ xs: 1, md: 1 }}>
                <Box sx={{ paddingLeft: { xs: 0, md: 3 } }}>
                  <p >
                    The ministry participates in the fulfillment of Jesus
                    Christ’s mission on earth through its spiritual Father, Rev.
                    Dominic Valanmanal. Fr. Dominic conducts deliverance prayers
                    worldwide to help people return to the Lord. Deliverance
                    prayers are primarily conducted at the Marian Retreat Centre
                    in Annakara, located in the state of Kerala, India. In his
                    mission, he dedicates more than half of his time traveling
                    to different locations spreading the good news. His efforts
                    remind us that “So if the Son sets you free, you will be
                    free indeed.”
                  </p>
                </Box>
              </Grid>
              <Grid item xs={12} md={6} order={{ xs: 2, md: 2 }}>
                <img
                  className="img-fluid shadow-sm"
                  src={`${process.env.PUBLIC_URL}/images/FrDominicInternational.jpg`}
                  alt="Blessing"
                />
              </Grid>
            </Grid>
          </div>
        </div>

        <FooterPanel />
      </React.Fragment>
    );
  }
}

export default WorldEvangelizationPage;
